import * as React from 'react';
import ChartLib from 'chart.js';
import { TDealType } from '@cian/api-models/offer-card/v1/get-offer-data';

import { Chart } from '../../components';
import { usePrepareChartConfig } from './utils/usePrepareChartConfig';
import { TChartData } from '../../types';
import { useTrackTooltipShow } from './utils/useTrackTooltipShow';
import { chartSaleLegend, chartRentLegend } from '../../constants';

interface IChartContainerProps {
  priceHistoryChartData: TChartData;
  dealType: TDealType;
}

export const ChartContainer: React.FC<IChartContainerProps> = props => {
  const chartCanvasRef = React.useRef<HTMLCanvasElement>(null);
  const [chartCtx, setChartCtx] = React.useState<CanvasRenderingContext2D | null>(null);
  const trackTooltipShow = useTrackTooltipShow();
  const chartLegend = props.dealType === 'sale' ? chartSaleLegend : chartRentLegend;

  const chartConfig = usePrepareChartConfig(chartCtx, {
    ...props.priceHistoryChartData,
    onHover: trackTooltipShow,
    dealType: props.dealType,
  });

  //Глобальные настройки для chart.js
  React.useEffect(() => {
    ChartLib.defaults.fontFamily = 'Lato, Arial, sans-serif';
    ChartLib.defaults.fontSize = 12;
  }, []);

  //Сохраняем canvas context в стейт
  React.useEffect(() => {
    /*istanbul ignore else*/
    if (chartCanvasRef.current) {
      const ctx = chartCanvasRef.current.getContext('2d');
      setChartCtx(ctx);
    }
  }, []);

  React.useEffect(() => {
    if (chartCtx && chartConfig) {
      //Возвращаемое значение в настоящий момент не требуется
      // tslint:disable-next-line:no-unused-expression
      new ChartLib(chartCtx, chartConfig);
    }
  }, [chartCtx, chartConfig]);

  return <Chart chartCanvasRef={chartCanvasRef} chartLegend={chartLegend} />;
};

ChartContainer.displayName = 'ChartContainer';
